var _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlidersDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15,
    y2: 14
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 20,
    y2: 18
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidersDark);
export default __webpack_public_path__ + "static/media/Sliders_Dark.ffdf3b020a3b679dddb5870e1cf4e60d.svg";
export { ForwardRef as ReactComponent };